/**
 * Grey bars standing for the rows of a table while its list is read, under
 * the table's own head: `columns` cells a row, as many as the head.
 */
const TableSkeleton = ({ columns, rows = 5, label }) => (
  <tbody aria-busy="true">
    {Array.from({ length: rows }, (_, row) => (
      <tr key={row} className="border-b border-gray-100">
        {Array.from({ length: columns }, (__, column) => (
          <td key={column} className={`py-7 ${column === 0 ? 'pl-4 pr-2' : column === columns - 1 ? 'pl-2 pr-3' : 'px-2'}`}>
            {column < columns - 1 && <div className="h-2 skeleton-bar" />}
            {row === 0 && column === 0 && label && (
              <span role="status" className="sr-only">
                {label}
              </span>
            )}
          </td>
        ))}
      </tr>
    ))}
  </tbody>
);

export default TableSkeleton;
